import type { GridApi, GridColumn } from './types'
import type { GridLeafColumn } from './useGridState'
import GridRow from './GridRow'
import classes from './grid-theme.module.scss'

interface PinnedBottomRowProps<T> {
  row: T
  rowId: string
  leafColumns: GridLeafColumn<T>[]
  api: GridApi<T>
  height: number
  totalWidth: number
  /** Kept in sync with the body's horizontal scroll by the grid. */
  innerRef?: React.Ref<HTMLDivElement>
  onCommit: (rowId: string, column: GridColumn<T>, row: T, value: unknown) => void
  onCancelEdit: () => void
}

/**
 * A summary row fixed below the body. It mirrors the body's horizontal scroll
 * rather than owning a scrollbar of its own.
 */
const PinnedBottomRow = <T,>({
  row,
  rowId,
  leafColumns,
  api,
  height,
  totalWidth,
  innerRef,
  onCommit,
  onCancelEdit,
}: PinnedBottomRowProps<T>) => (
  <div className={classes.pinnedBottom} style={{ height }}>
    <div ref={innerRef} style={{ width: totalWidth, minWidth: '100%' }}>
      <GridRow
        row={row}
        rowId={rowId}
        rowIndex={-1}
        leafColumns={leafColumns}
        api={api}
        isPinnedBottom
        isLast
        editingField={null}
        pendingEdit={null}
        style={{ height }}
        onCellClick={() => undefined}
        onCommit={onCommit}
        onCancelEdit={onCancelEdit}
      />
    </div>
  </div>
)

export default PinnedBottomRow
